import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDataTableCustomer(payload) {
	return axios.post(`${Constants.baseUrl}/customer/list`, payload);
}

export function getCustomerCorporate(id) {
	return axios.get(`${Constants.baseUrl}/customer-corporate/${id}`);
}

export function getCustomerPerson(id, details = 0) {
	return axios.get(`${Constants.baseUrl}/customer-person/${id}?details=${details}`);
}

export function getSimpleList() {
	return axios.get(`${Constants.baseUrl}/customer/simpleList`);
}

export function getSimpleListSubsidiary() {
	return axios.get(`${Constants.baseUrl}/customer/simpleListSubsidiary`);
}

export function getSimpleListSegment() {
	return axios.get(`${Constants.baseUrl}/customer/simpleListSegment`);
}

export function getSimpleListTeam(id) {
	return axios.get(`${Constants.baseUrl}/customer/simpleListTeam/${id}`);
}

export function getSimpleListUserGroup(id) {
	return axios.get(`${Constants.baseUrl}/customer/simpleListUserGroup/${id}`);
}

export function createCustomer(payload) {
	return axios.post(`${Constants.baseUrl}/customer`, payload);
}
export function updateCustomer(payload, id) {
	return axios.patch(`${Constants.baseUrl}/customer/${id}`, payload);
}

export function destroyCustomer(id) {
	return axios.delete(`${Constants.baseUrl}/customer/${id}`);
}

// Empresa
export function updateCustomerCorporate(payload, id) {
	return axios.patch(`${Constants.baseUrl}/customer-corporate/${id}`, payload);
}

export function updateCampaignConfig(payload, id) {
	return axios.post(`${Constants.baseUrl}/customer/campaign-config/${id}`, payload);
}